import * as React from 'react';
import { StyleSheet, View, Pressable } from 'react-native';

const styles = StyleSheet.create({
  button: {
    backgroundColor: 'transparent',
  },
  disabled: {
    opacity: 0.65,
  },
});

type Props = Record<string, any>;

export const Button = (props: Props): React.JSX.Element => {
  const { style, disabled, children, onPress, onLongPress, ...rest } = props;

  // We use a View for the disabled/static state to avoid touch calculations
  if (disabled || !(onPress || onLongPress)) {
    const flattened = StyleSheet.flatten(style);
    return (
      <View 
        style={[
          styles.button, 
          style, 
          styles.disabled, 
          { elevation: 0, shadowOpacity: 0 } // Fix bleed for disabled state
        ]} 
        {...rest}
      >
        {children}
      </View>
    );
  }

  return (
    <Pressable
      {...rest}
      onPress={onPress}
      onLongPress={onLongPress}
      testID="commonButton"
      style={({ pressed }) => [
        styles.button,
        // Default Elevation for Android (applied when not pressed)
        { elevation: 5, shadowColor: "#000", shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.5, shadowRadius: 3.84 },
        style,
        // The Fix: Kill elevation/shadow and reduce opacity when pressed
        pressed && { 
          opacity: 0.7, 
          elevation: 0, 
          shadowOpacity: 0 
        }
      ]}
    >
      {children}
    </Pressable>
  );
};